<template>
  <div>
    <div class="position-relative">
      <div class="app-btn-container">
        <!-- target for button teleport -->
        <div id="appButton" />
      </div>
    </div>
    <AppNavbar />
  </div>
</template>

<script >
import AppNavbar from '@/modules/builder/components/application/AppNavbar.vue';
import { useRouter } from '@/hooks/vueRouter';
import * as ROUTES from '@/router/routeConstants';

// compose hooks
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const router = useRouter();
  const openPage = location => {
    router.push(location);
  };
  return {};
};
__sfc_main.components = Object.assign({
  AppNavbar
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss">
.app-navbar {
  &.b-tabs {
    margin-bottom: 0;
    .tab-content {
      padding: 0;
    }
  }
}
.app-btn-container {
  display: flex;
  position: absolute;
  right: 0;
  top: -50px;
  .app-btn {
    font-size: 0.875rem;
    margin-right: 0.625rem;
    &:last-child {
      margin-right: 0;
    }
  }
  .add-new-btn {
    font-size: 0.875rem;
    border-radius: 0.5rem;
    margin-right: 0.625rem;
    .icon {
      margin-right: 1px !important;
    }
  }
}
</style>
